package com.wintermar.inspection.feature.data.repository.answer

import com.wintermar.inspection.AppDatabase
import com.wintermar.inspection.core.domain.Result
import com.wintermar.inspection.feature.data.local.db.SqliteCompat
import com.wintermar.inspection.feature.data.remote.mapper.answer.toAnswerLocationModel
import com.wintermar.inspection.feature.domain.model.answer.AnswerLocationModel
import com.wintermar.inspection.feature.domain.repository.answer.AnswerLocationRepository
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext

class AnswerLocationRepositoryImpl(
    private val appDatabase: AppDatabase
) : AnswerLocationRepository {
    override suspend fun insertAnswerLocation(answerLocation: AnswerLocationModel): Result<Unit> {
        return withContext(Dispatchers.Default) {
            try {
                appDatabase.transaction {
                    val executableQuery = SqliteCompat.selectInsertImplementation(
                        appDatabase = appDatabase,
                        upsert = appDatabase.answerLocationTableQueries::insertAnswerLocation,
                        replace = appDatabase.answerLocationTableQueries::insertReplaceAnswerLocation
                    )
                    executableQuery(
                        answerLocation.id,
                        answerLocation.answerId,
                        answerLocation.name,
                        answerLocation.latitude,
                        answerLocation.longitude,
                        answerLocation.street,
                        answerLocation.isoCountryCode,
                        answerLocation.country,
                        answerLocation.postalCode,
                        answerLocation.administrativeArea,
                        answerLocation.subAdministrativeArea,
                        answerLocation.locality,
                        answerLocation.subLocality,
                        answerLocation.thoroughfare,
                        answerLocation.subThoroughfare
                    )
                }
                Result.Success(Unit)
            } catch (e: Exception) {
                Result.Error(e)
            }
        }
    }

    override suspend fun deleteAnswerLocationByAnswerId(answerId: String): Result<Unit> {
        return withContext(Dispatchers.Default) {
            try {
                appDatabase.transaction {
                    appDatabase.answerLocationTableQueries.deleteAnswerLocationByAnswerId(answerId)
                }
                Result.Success(Unit)
            } catch (e: Exception) {
                Result.Error(e)
            }
        }
    }

    override suspend fun deleteAnswerLocationByAnswerIds(answerIds: List<String>): Result<Unit> {
        return withContext(Dispatchers.Default) {
            try {
                appDatabase.transaction {
                    appDatabase.answerLocationTableQueries.deleteAnswerLocationByAnswerIds(answerIds)
                }
                Result.Success(Unit)
            } catch (e: Exception) {
                Result.Error(e)
            }
        }
    }

    override suspend fun getAnswerLocationByAnswerId(answerId: String): Result<AnswerLocationModel> {
        return withContext(Dispatchers.Default) {
            try {
                val result = appDatabase.transactionWithResult {
                    appDatabase.answerLocationTableQueries
                        .getAnswerLocationByAnswerId(answerId)
                        .executeAsOne()
                        .toAnswerLocationModel()
                }
                Result.Success(result)
            } catch (e: Exception) {
                Result.Error(e)
            }
        }
    }
}
